import HHH from "../assets/images/HHH.png";
import logoHHHmyH26 from "../assets/images/logo-HHH-myH26.png";
import logonMyh from "../assets/images/logonMyh.png";
import HHH_SG from "../assets/images/logo-HHH.png";
// import HHH_SG from "../assets/images/HHH-SG.png";
import TTHH from "../assets/images/Quy trai tim Hung Hau.png";
import HHC from "../assets/images/HHC.png";
import myU from "../assets/images/logo_myU.png";
import VES from "../assets/images/VES.png";
import VHU from "../assets/images/VHU.png";
import WCD from "../assets/images/WCD.png";
import ALC from "../assets/images/ALC.png";
import ALH from "../assets/images/ALH.png";
import DFC from "../assets/images/DFC.png";
import HCM from "../assets/images/HCM.png";
import HEB from "../assets/images/HEB.png";
import HEH from "../assets/images/HEH.png";
import HET from "../assets/images/HET.png";
import HHA from "../assets/images/HHA.png";
import HHD from "../assets/images/HHD.png";
import HHE from "../assets/images/HHE.png";
import HHF from "../assets/images/HHF.png";
import MNAL from "../assets/images/MNAL.png";
import HHN from "../assets/images/Nakydaco.png";

export const logoOptions = [
  HHH_SG,
  logoHHHmyH26,
  HHH,
  TTHH,
  VHU,
  logonMyh,
  myU,
  HHC,
  HHA,
  HHD,
  HHE,
  HHF,
  HEB,
  HEH,
  HET,
  ALH,
  ALC,
  DFC,
  HCM,
  WCD,
  MNAL,
  VES,
  HHN,
];
